import {
  cookie
} from '@/commons/utils'
/**
 * 消息通知
 */
function push () {
  const w = window
  let hasPermission = false,
    notifications = {}, // map
    currentId = 0,
    /**
     * 检测用户的浏览器是否支持通知
     */
    isSupported = (function () {
      let isSupported = false
      try {
        isSupported =

          /* Safari, Chrome */
          !!(w.Notification ||

            /* Chrome & ff-html5notifications plugin */
            w.webkitNotifications ||

            /* Firefox Mobile */
            navigator.mozNotification ||

            /* IE9+ */
            (w.external && w.external.msIsSiteMode() !== undefined))
      } catch (e) {}

      return isSupported
    })(),
    /**
     * 关闭一个通知
     */
    closeNotification = function (id) {
      let errored = false,
        notification = notifications[id]
      if (typeof notification !== 'undefined') {
        // Safari 6+, Chrome 23+
        if (notification.close) {
          notification.close()
        }
        // webkit
        else if (notification.cancel) {
          notification.cancel()
        }
        // IE9 +
        else if (w.external && w.external.msIsSiteMode) {
          w.external.msSiteModeClearIconOverlay()
        } else {
          errored = true
          alert('')
        }
        if (!errored) {
          return removeNotification(id)
        }
      }
      return false
    },
    addNotification = function (notification) {
      let id = currentId
      notifications[id] = notification
      currentId++
      return id
    },
    // 删除notifications里对应的id
    removeNotification = function (id) {
      let dict = {},
        success = false
      for (let key in notifications) {
        if (notifications.hasOwnProperty(key)) {
          if (key != id) {
            dict[key] = notifications[key]
          } else {
            success = true
          }
        }
      }
      notifications = dict
      return success
    },
    createCallback = function (title, options) {
      let notification,
        wrapper,
        id,
        onClose
      options = options || {}
      // Safari 6+, Firefox 22+, Chrome 22+, Opera 25+
      if (w.Notification) {
        notification = new w.Notification(
          title, {
            icon: options.icon || '',
            body: options.body,
            tag: options.tag,
            requireInteraction: options.requireInteraction
          }
        )
      }
      // webkit
      else if (w.webkitNotifications) {
        notification = w.webkitNotifications.createNotification(
          options.icon,
          title,
          options.body
        )
        notification.show()
      }
      // firefox
      else if (navigator.mozNotification) {
        notification = navigator.mozNotification.createNotification(
          title,
          options.body,
          options.icon
        )
        notification.show()
      }
      // ie9+
      else if (w.external && w.external.msIsSiteMode()) {
        w.external.msSiteModeClearIconOverlay()
        w.external.msSiteModeSetIconOverlay(
          ((isString(options.icon) || isUndefined(options.icon))
            ? options.icon
            : options.icon.x16), title
        )
        w.external.msSiteModeActivate()
        notification = {}
      } else {
        throw new Error('Unable to create notification: unknown interface')
      }

      id = addNotification(notification)

      wrapper = {
        get: function () {
          return notification
        },

        close: function () {
          closeNotification(id)
        }
      }

      if (options.timeout) {
        setTimeout(function () {
          wrapper.close()
        }, options.timeout)
      }
      // 回调事件
      if (typeof options.onShow === 'function') {
        notification.addEventListener('show', options.onShow)
      }
      if (typeof options.onError === 'function') {
        notification.addEventListener('error', options.onError)
      }
      if (typeof options.onClick === 'function') {
        notification.addEventListener('click', options.onClick)
      }

      onClose = function () {
        removeNotification(id)
        if (typeof options.onClose !== 'undefined') {
          options.onClose.call(this)
        }
      }

      notification.addEventListener('close', onClose)
      notification.addEventListener('cancel', onClose)

      return wrapper
    },

    Permission = {
      DEFAULT: 'default',
      GRANTED: 'granted',
      DENIED: 'denied',
      // 请求许可
      request: function (onGranted, onDenied) {
        if (!isSupported) {
          return false
        }
        const self = this,
          callback = function (result) {
            switch (result) {
              case self.GRANTED:
                hasPermission = true
                if (onGranted) onGranted()
                break

              case self.DENIED:
                hasPermission = false
                if (onDenied) onDenied()
                break
            }
          }
        /* Safari 6+, Chrome 23+ */
        if (w.Notification && w.Notification.requestPermission) {
          Notification.requestPermission(callback)
        }
        /* webkit */
        else if (w.webkitNotifications && w.webkitNotifications.checkPermission) {
          w.webkitNotifications.requestPermission(callback)
        }
      },
      // 返回按是已经请求许可
      has: function () {
        return hasPermission
      },
      // 返回是否已经授权
      get: function () {
        let permission

        if (!isSupported) {
          return false
        }

        /* Safari 6+, Chrome 23+ */
        if (w.Notification && w.Notification.permissionLevel) {
          permission = w.Notification.permissionLevel

          /* Legacy webkit browsers */
        } else if (w.webkitNotifications && w.webkitNotifications.checkPermission) {
          permission = Permissions[w.webkitNotifications.checkPermission()]

          /* Firefox 23+ */
        } else if (w.Notification && w.Notification.permission) {
          permission = w.Notification.permission

          /* Firefox Mobile */
        } else if (navigator.mozNotification) {
          permission = Permissions.GRANTED

          /* IE9+ */
        } else if (w.external && w.external.msIsSiteMode() !== undefined) {
          permission = w.external.msIsSiteMode() ? Permission.GRANTED : Permission.DEFAULT
        } else {
          return false
        }

        return permission
      }

    },

    Permissions = [Permission.GRANTED, Permission.DEFAULT, Permission.DENIED]

  return {
    notifications: notifications,
    Permission: Permission,
    isSupported: isSupported,
    createCallback: createCallback,
    closeNotification: closeNotification,
    addNotification: addNotification,
    removeNotification: removeNotification
  }
}
const flashPush = push()
const cookieName = 'notification'
const flashNotification = {
  isDenied () {
    return flashPush.Permission.get() === flashPush.Permission.DENIED
  },
  isGranted () {
    return flashPush.Permission.get() === flashPush.Permission.GRANTED
  },
  getState () {
    return cookie.get(cookieName)
  },
  close () {
    cookie.set(cookieName, 'close')
  },
  open () {
    cookie.set(cookieName, 'open')
    // this.request()
  },
  request (callback) {
    if (!this.isGranted()) {
      flashPush.Permission.request(callback)
    }
  },
  create (title, options) {
    if (!flashPush.isSupported || this.getState(cookieName) == 'close') {
      return false
    }
    if (!flashPush.Permission.has()) {
      flashPush.Permission.request(() => {
        this.open()
        flashPush.createCallback(title, options)
      })
    } else {
      flashPush.createCallback(title, options)
    }
  }
}
export default flashNotification



// WEBPACK FOOTER //
// ./src/views/index/modules/push.js